import React, { useEffect, useRef, useState } from "react";
import {
  updateCollegeDetails,
} from "../../../Services/HomeService";
import toast from "react-hot-toast";
import moment from "moment";




const CollegeUniversityStep13 = ({ data, setData, setCurrentStep, currentStep }) => {
  const initialValues = {
    // counsellingImportantDatesHeading: data?.counsellingImportantDatesHeading,
    nirfRanking: data?.nirfRanking
  }
  const [formData, setFormData] = useState(initialValues);
  const [formDataLoading, setFormDataLoading] = useState(false);

  const handleBack = (e) => {
    e?.preventDefault();
    setCurrentStep(currentStep - 1)
  }

  const handleUpdate = async (e) => {
    e?.preventDefault();
    try {
      setFormDataLoading(true);
      const res = await updateCollegeDetails(data?._id, formData);
      console.log("College Add Step2 Message ", res);
      if (res?.status) {
        // toast.success(res?.message);
        setFormData(initialValues)
        setFormDataLoading(false);
        setData({
          ...data,
          // counsellingImportantDatesHeading: formData?.counsellingImportantDatesHeading,
          nirfRanking: formData?.nirfRanking
        })
        setCurrentStep(currentStep + 1)
      } else {
        toast.error(res?.message);
        setFormDataLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add College.");
      console.error("Error adding College:", error);
      setFormDataLoading(false);
    }
  };

  /////////////////////////////////////
  const initialItem = {
    category: "",
    rank: "",
    year: moment().year(),
    description: "",
    nirfScore: 0
  };

  const initialItems = data?.nirfRanking?.length ? data?.nirfRanking : [initialItem]

  const [items, setItems] = useState(initialItems);
  const handleMultiChange = (i, e) => {
    let newFormValues = [...items];
    if (e.target.name === "year" || e.target.name === "rank") {
      newFormValues[i][e.target.name] = parseInt(e.target.value);
    } else if (e.target.name === "nirfScore") {
      newFormValues[i][e.target.name] = parseFloat(e.target.value);
    }else {
      newFormValues[i][e.target.name] = e.target.value;
    }
    setItems(newFormValues);
    setFormData({ ...formData, nirfRanking: newFormValues })
  };

  const addItem = () => {
    if (items?.length < 5000) {
      setItems([...items, initialItem]);
    }
  };

  const removeProducts = (i) => {
    let newFormValues = [...items];
    newFormValues.splice(i, 1);
    setItems(newFormValues);
    setFormData({ ...formData, nirfRanking: newFormValues })
  };

    useEffect(() => {
      setFormData(initialValues)
    }, [data])

  return (
    <>

      <section className="chartBox_area">
        <form
          onSubmit={(e) => {
            handleUpdate(e);
          }}
        >
          <div className="row d-flex justify-content-center">





            {/* <div className="col-md-12 mt-3">
              <label htmlFor="name">
                Counselling Heading<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={formData?.rank}
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    rank: e?.target?.value,
                  }));
                }}
                placeholder="Enter Heading Text"
              />
            </div> */}

            <div className="col-md-12 mt-3">
              <label>
                NIRF Ranking <button
                  className="btn btn-sm btn-success"
                  type="button"
                  onClick={() => addItem()}
                >
                  <i class="fas fa-plus"></i> Add
                </button>
              </label>
              {items?.map((element, index) => (

                <div
                  // style={{ border: "solid 1px #ced4da", padding: "1em", margin: "0 0 1em 0", borderRadius: "0.25rem" }}
                  className="_form-inline row" key={index}>

                  <div className="col-md-4 mb-2 mt-1">
                    <label>
                      Description:
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      name="description"
                      // placeholder={`description ${index + 1}`}
                      value={element.description || ""}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>

                  <div className="col-md-2 mb-2 mt-1">
                    <label>
                      Category:
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      name="category"
                      // placeholder={`Category ${index + 1}`}
                      value={element.category || ""}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>

                  <div className="col-md-2 mb-2 mt-1">
                    <label>
                      Year:
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      name="year"
                      // placeholder={`Year ${index + 1}`}
                      value={element.year || ""}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>

                  <div className="col-md-2 mb-2 mt-1">
                    <label>
                      Rank:
                    </label>
                    <input
                      type="number"
                      class="form-control"
                      name="rank"
                      // placeholder={`Rank ${index + 1}`}
                      value={element.rank || ""}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>

                  <div className="col-md-2 mb-2 mt-1">
                    <label>
                      Score:
                    </label>
                    <input
                      type="number"
                      class="form-control"
                      name="nirfScore"
                      // placeholder={`Score ${index + 1}`}
                      value={parseFloat(element.nirfScore) || 0}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>

                  {index ? (
                    <div
                      style={{
                        position: "absolute",
                        right: "25px"
                      }}
                    >
                      <i class="fas fa-times"
                        style={{
                          color: "#ff0000",
                          cursor: "pointer",
                          fontSize: "1em"
                        }}
                        onClick={() => removeProducts(index)}
                      ></i>
                    </div>
                  ) : null}




                </div>

              ))}
            </div>

          </div>
          <div className=" d-flex justify-content-end">
            {
              currentStep > 2 &&
              <button
                type="button"
                className="btn mt-3"
                style={{
                  background: "rgb(133, 218, 79)",
                  borderRadius: "13px",
                  marginRight: "15px"
                }}
                onClick={(e) => handleBack(e)}
              >Back
              </button>
            }

            <button
              disabled={formDataLoading}
              type="submit"
              className="btn mt-3"
              style={{
                background: "rgb(133, 218, 79)",
                borderRadius: "13px",
              }}
            >
              {formDataLoading
                ? "Saving..."
                // : "Add College/University"
                : `Save & Continue`
              }
            </button>
          </div>
        </form>
      </section>

    </>
  );
};

export default CollegeUniversityStep13;
